import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/nurseryApi";
import { Plus, PencilSimple, Trash, Eye, EyeSlash, Calendar } from "@phosphor-icons/react";
import BackToOverview from "../../components/BackToOverview";

export default function AdminBlog() {
  const [posts, setPosts] = useState([]);
  const nav = useNavigate();

  const load = () => api.get("/admin/blog").then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);

  const del = async (p) => {
    if (!window.confirm(`Delete "${p.title}"? This cannot be undone.`)) return;
    await api.delete(`/admin/blog/${p.id}`);
    load();
  };

  return (
    <div data-testid="admin-blog-page" className="fade-up">
      <BackToOverview />
      <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--secondary)" }}>Content desk</div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 14, marginBottom: 24 }}>
        <div>
          <h1 className="page-title" style={{ marginTop: 8 }}>Blog Posts</h1>
          <p style={{ color: "var(--muted-fg)", marginTop: 6, fontSize: 14.5 }}>{posts.length} posts · published posts appear at /blog.</p>
        </div>
        <button className="btn btn-primary" onClick={() => nav("/admin/blog/new")} data-testid="new-post-btn">
          <Plus size={16} weight="bold" /> New post
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: 16 }}>
        {posts.map((p) => (
          <div key={p.id} className="card card-hover" style={{ padding: 0, overflow: "hidden", display: "flex", flexDirection: "column" }} data-testid={`post-card-${p.id}`}>
            {p.cover_image && (
              <div style={{ height: 160, overflow: "hidden", background: "var(--bg-alt)" }}>
                <img src={p.cover_image} alt={p.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
            )}
            <div style={{ padding: 20, flex: 1, display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span className="badge badge-soft">{p.tag}</span>
                <span className={`badge ${p.published ? "badge-success" : "badge-warn"}`}>
                  {p.published ? <><Eye size={11} weight="bold" /> live</> : <><EyeSlash size={11} weight="bold" /> draft</>}
                </span>
              </div>
              <h3 className="font-display" style={{ fontSize: 22, marginTop: 12, lineHeight: 1.15 }}>{p.title}</h3>
              <p style={{ fontSize: 13.5, color: "var(--text-soft)", marginTop: 8, lineHeight: 1.55, flex: 1 }}>{p.excerpt}</p>
              <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, fontSize: 12, color: "var(--muted-fg)" }}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <Calendar size={12} weight="bold" /> {new Date(p.updated_at).toLocaleDateString()}
                </span>
                <div style={{ display: "flex", gap: 6 }}>
                  <Link to={`/admin/blog/${p.id}`} className="btn btn-ghost" style={{ minHeight: 32, padding: "6px 10px", fontSize: 12 }} data-testid={`edit-post-${p.id}`}>
                    <PencilSimple size={14} weight="bold" /> Edit
                  </Link>
                  <button className="btn btn-ghost" style={{ minHeight: 32, padding: "6px 10px" }} onClick={() => del(p)} data-testid={`del-post-${p.id}`}>
                    <Trash size={14} weight="bold" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {posts.length === 0 && (
          <div className="card" style={{ padding: 40, textAlign: "center", color: "var(--muted-fg)" }}>
            No posts yet. <Link to="/admin/blog/new" style={{ color: "var(--primary)", fontWeight: 700, textDecoration: "underline" }}>Write your first one →</Link>
          </div>
        )}
      </div>
    </div>
  );
}
